export const sessionActions = {
  BOOK: "BOOK",
  CANCEL: "CANCEL",
  JOIN: "JOIN",
  UPGRADE: "UPGRADE",
  FULL: "FULL",
  EXPIRED: "EXPIRED",
  BOOKING_CLOSED: "BOOKING_CLOSED",
  CANCELLED: "CANCELLED",
};